import { FormInstance } from "antd";

export function hasFormTouched(form: FormInstance) {
  const fields = form.getFieldsValue(true, (meta) => meta.touched);
  return Object.keys(fields).length > 0;
}
